import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthServiceLocal } from 'src/@order/services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class ForcedLogoutGuardGuard implements CanActivate {
  constructor(private router: Router, private _AuthServiceLocal: AuthServiceLocal) { }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    console.log("route", route);

    const userToken = localStorage.getItem('PWAToken');
    if (userToken) {
      // Use the auth service logout method to ensure bottom sheets are closed
      this._AuthServiceLocal.userLogout();
    }
    return true

  }

  //     if (userToken) {
  //       this.router.navigate(['/order/home'])
  //       return false
  //     } else {
  //       if (!route.queryParamMap.get('userId')) {
  //         return true
  //       } else {
  //         return new Promise((resolve, reject) => {
  //           Promise.all([
  //             this._AuthServiceLocal.getCustomerDetails({ userId: route.queryParamMap.get('userId') }).then((res) => {
  //               if (res) {
  //                 this.router.navigate(['/order/home'])
  //                 return false
  //               } else {
  //                 reject
  //                 return true
  //               }
  //             })
  //           ]).then(() => {
  //             resolve(true)
  //           })
  //         })

  //       }
  //     }
  //   }

}
